export default __webpack_public_path__ + "static/integrity-4933b20fc74aba83707a0fc38b781242.svg";